import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/_services/app.service";

@Component({
  selector: "app-first-demand",
  templateUrl: "./first-demand.component.html",
  styleUrls: ["./first-demand.component.scss"],
  standalone: false,
})
export class FirstDemandComponent implements OnInit {
  @Output() cancle: EventEmitter<any> = new EventEmitter<any>();

  constructor(private appService: AppService) {}

  ngOnInit() {}
  handleCancle() {
    this.appService.dispatchModal("FREE_DEMAND_MODAL", false);
    this.cancle.emit();
  }
}
